import { IFilterList } from './DataTable'

export function extractFilterValue(e: any, val: any): any {
  let storedValue: any = undefined
  if (val) {
    if (Array.isArray(val)) {
      storedValue = val.map((date) => (date?.isValid?.() ? date.format('YYYY-MM-DD') : date))
    } else if (val?.isValid?.()) {
      storedValue = val.format('YYYY-MM-DD')
    } else if (val?.value) {
      storedValue = val?.value
    }
  }
  if (typeof storedValue === 'undefined' && e?.target?.value !== undefined) {
    storedValue = e.target.value
  }
  return storedValue
}

export function buildFilterSubmitPayload(
  filter: IFilterList | undefined,
  tempFilterValues: Record<string, any>,
  existingFilters: Record<string, any>,
): Record<string, any> | null {
  const filterVal = filter && tempFilterValues[filter.id]
  const id = filter?.id
  if (filterVal && id) {
    return { ...existingFilters, [id]: filterVal }
  }
  return null
}
